import React from 'react';

import {FilterKey, MultiValueFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import UserSearchByLabelFilterForm from './base/UserSearchByLabelFilterForm';

interface UsersFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter; // values are handles, not IDs
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
}

// Populates filter with the users' handle. Use UsersApiIdFilterForm if you need the filter to be populated
// with the users' API ID.
function UsersFilterForm(props: UsersFilterFormProps): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  let prefix;
  switch (props.filter.key) {
    case FilterKey.AUTHOR:
      prefix = 'Author';
      break;
    case FilterKey.CREATOR:
      prefix = 'Creator';
      break;
    case FilterKey.REQUEST_REQUESTOR:
      prefix = 'Requestor';
      break;
    default:
      throw new Error(`UsersFilterForm got unexpected filter key ${props.filter.key}`);
  }
  return (
    <UserSearchByLabelFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      onChangeHandles={(handles) => {
        props.onChangeFilter({...props.filter, value: handles});
      }}
      onEnter={props.onEnter}
      onRemove={props.onRemove}
      handles={props.filter.value}
      prefix={prefix}
    />
  );
}

export default UsersFilterForm;
